import UploadGuideLines from './UploadGuideLines'
export default UploadGuideLines
